// extracted by mini-css-extract-plugin
export default {"root":"InfoCard_root__VMZyH","bg-warn":"InfoCard_bg-warn__MHG7F","bg-normal":"InfoCard_bg-normal__pS1xj","title":"InfoCard_title__4SDjk","desc":"InfoCard_desc__RSrV1"};